export const SIDEBAR_FAB_SIZE = 52;
export const SIDEBAR_FAB_MARGIN = 20;
export const SIDEBAR_FAB_DRAG_THRESHOLD = 6;
export const SIDEBAR_FAB_STORAGE_KEY = "sidebarFabRatio";

function fabBounds(viewportHeight, fabSize, margin) {
  const min = margin;
  const max = Math.max(min, viewportHeight - fabSize - margin);
  return { min, max };
}

/** Keeps the menu tab inside the viewport. Invalid values sit at the bottom. */
export function clampSidebarFabTop(
  top,
  viewportHeight,
  fabSize = SIDEBAR_FAB_SIZE,
  margin = SIDEBAR_FAB_MARGIN,
) {
  const { min, max } = fabBounds(viewportHeight, fabSize, margin);
  const value = Number(top);
  if (!Number.isFinite(value)) return max;
  return Math.round(Math.min(max, Math.max(min, value)));
}

/** 0 = top, 1 = bottom. Missing or junk storage means "use the default". */
export function readSidebarFabRatio(raw) {
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  if (!Number.isFinite(n)) return null;
  return Math.min(1, Math.max(0, n));
}

export function sidebarFabTopFromRatio(
  ratio,
  viewportHeight,
  fabSize = SIDEBAR_FAB_SIZE,
  margin = SIDEBAR_FAB_MARGIN,
) {
  const { min, max } = fabBounds(viewportHeight, fabSize, margin);
  const stored = readSidebarFabRatio(ratio);
  const safe = stored == null ? 1 : stored;
  return Math.round(min + (max - min) * safe);
}

export function sidebarFabRatioFromTop(
  top,
  viewportHeight,
  fabSize = SIDEBAR_FAB_SIZE,
  margin = SIDEBAR_FAB_MARGIN,
) {
  const { min, max } = fabBounds(viewportHeight, fabSize, margin);
  const span = max - min;
  if (span <= 0) return 1;
  const clamped = clampSidebarFabTop(top, viewportHeight, fabSize, margin);
  return (clamped - min) / span;
}

/** The dashboard chip sits below the icon when there is no room above it. */
export function sidebarFabDashBelow(
  top,
  fabSize = SIDEBAR_FAB_SIZE,
  margin = SIDEBAR_FAB_MARGIN,
) {
  return top < fabSize + margin;
}
